import { useState, useEffect, useRef } from 'react';
import styles from './SearchPage.module.css';

import { Header } from '../../components/Header/Header';
import { MinSliderCard } from '../../components/Slider/minSliderCard/minSliderCard';
import { useDebounce } from '../../hooks/debounce';
import { useAllItemsQuery } from '../../store/api/item.api';
import { useAllSubscriptionsQuery } from '../../store/api/subscription.api';

import magnifierIcon from '../../assets/magnifier-icon.svg';

export const SearchPage = () => {
	const schema = window.sessionStorage.getItem("schema");

	// Восстановление значения поиска из sessionStorage
	const [searchValue, setSearchValue] = useState(() => sessionStorage.getItem('searchValue') || "");
	const debouncedSearch = useDebounce(searchValue, 400);
	const inputRef = useRef(null);

	useEffect(() => {
		inputRef.current?.focus();
	}, []);

	useEffect(() => {
		sessionStorage.setItem('searchValue', searchValue);
	}, [searchValue]);

	const { data: itemsData = [], isLoading: isItemsLoading } = useAllItemsQuery(
		debouncedSearch ? { params: { title: debouncedSearch }, schema } : {},
		{ skip: !debouncedSearch }
	);

	const { data: subsData = [], isLoading: isSubsLoading } = useAllSubscriptionsQuery(
		debouncedSearch.length > 3 && schema === '' ? { title: debouncedSearch, schema } : {},
		{ skip: debouncedSearch.length <= 3 || schema !== '' }
	);

	const handleChange = (event) => {
		setSearchValue(event.target.value);
	};

	return (
		<div className={"main"}>
			<Header />
			<div className={'title_block'}>
				<img src={magnifierIcon} alt="magnifierIcon" />
				<h2>Результаты поиска</h2>
			</div>

			<div className={styles.search}>
				<input
					type="text"
					placeholder="Поиск"
					value={searchValue}
					onChange={handleChange}
					ref={inputRef}
				/>
				<img src={magnifierIcon} alt="magnifierIcon" />
			</div>

			<div className={`result_container`}>
				{(isItemsLoading || isSubsLoading) ? (
					<p>Загрузка...</p>
				) : (
					<>
						{itemsData.length === 0 && subsData.length === 0 && (
							<p>Ничего не найдено</p>
						)}

						{searchValue.length > 2 && itemsData.map((item) => (
							<MinSliderCard
								from='search'
								style={{height: 372}}
								key={item.id}
								title={item.title}
								price={item.price}
								price_disc={item.min_price || item.price_disc}
								devices={item.devices}
								lang={item.lang}
								img={item.img}
								itemId={item.id}
								buyBtn={true}
								category={'item'}
							/>
						))}

						{subsData.map((sub) => (
							<MinSliderCard
								from='search'
								key={sub.id}
								title={sub.title}
								price={sub.price}
								devices={sub.devices}
								img={sub.img}
								subCategory={sub.category}
								subscriptionId={sub.id}
								buyBtn={true}
								style={{height: 300}}
								subTime={sub.time}
							/>
						))}
					</>
				)}
			</div>
		</div>
	);
};
